import { fmtCFA, fmtDate } from "@/lib/format";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { Printer } from "lucide-react";
import { payLabel } from "@/hooks/useCaisse";

export const PAIEMENTS = {
  especes: { label: "Espèces", badge: "border-emerald-500/40 text-emerald-600 dark:text-emerald-400" },
  wave: { label: "Wave", badge: "border-sky-500/40 text-sky-600 dark:text-sky-400" },
  orange_money: { label: "Orange Money", badge: "border-orange-500/40 text-orange-600 dark:text-orange-400" },
};

export default function VentesJour({ data, onPrint }) {
  return (
    <Card className="bg-card border-border" data-testid="ventes-history">
      <CardHeader>
        <CardTitle className="text-base font-semibold text-foreground">{data.vue_complete ? "Historique des ventes du jour" : "Mes ventes du jour"}</CardTitle>
        {!data.vue_complete && (
          <p className="text-xs text-muted-foreground" data-testid="ventes-scope-note">
            Vous voyez uniquement vos propres ventes ({data.mes_ventes.nb_ventes} — {fmtCFA(data.mes_ventes.total)}). Les totaux ci-dessus concernent toute la caisse.
          </p>
        )}
      </CardHeader>
      <CardContent>
        <Table>
          <TableHeader>
            <TableRow className="border-border">
              <TableHead className="text-muted-foreground">Heure</TableHead>
              <TableHead className="text-muted-foreground">Articles</TableHead>
              <TableHead className="text-muted-foreground">Vendeur</TableHead>
              <TableHead className="text-muted-foreground">Paiement</TableHead>
              <TableHead className="text-muted-foreground text-right">Total</TableHead>
              <TableHead className="text-muted-foreground text-right">Reçu</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {data.ventes.length === 0 && (
              <TableRow className="border-border">
                <TableCell colSpan={6} className="text-center text-muted-foreground py-6" data-testid="ventes-empty">Aucune vente aujourd'hui</TableCell>
              </TableRow>
            )}
            {data.ventes.map((v) => (
              <TableRow key={v.id} className="border-border" data-testid={`vente-row-${v.id}`}>
                <TableCell className="text-foreground/80 text-sm">{fmtDate(v.created_at)}</TableCell>
                <TableCell className="text-foreground/80 text-sm">{v.items.map((i) => `${i.quantite}× ${i.nom}`).join(", ")}</TableCell>
                <TableCell className="text-muted-foreground text-sm">{v.vendeur_nom}</TableCell>
                <TableCell>
                  <Badge variant="outline" className={PAIEMENTS[v.paiement]?.badge || "border-border text-muted-foreground"}>{payLabel(v.paiement)}</Badge>
                  {v.reference && <span className="block text-[11px] text-muted-foreground mt-1" data-testid={`vente-ref-${v.id}`}>Réf. {v.reference}</span>}
                </TableCell>
                <TableCell className="text-right text-emerald-600 dark:text-emerald-400 font-semibold text-sm">{fmtCFA(v.total)}</TableCell>
                <TableCell className="text-right">
                  <Button size="icon" variant="ghost" className="h-8 w-8 text-muted-foreground hover:text-emerald-600" data-testid={`print-vente-${v.id}`} onClick={() => onPrint(v)}>
                    <Printer className="w-4 h-4" />
                  </Button>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </CardContent>
    </Card>
  );
}
